import React, { Fragment } from 'react';
import { Box, BoxProps } from '@mui/material';
import { styled } from '@mui/material/styles';

const ProgressWrapper = styled(Box, {
  shouldForwardProp: (prop) => prop !== 'height',
})<{
  height: number;
}>(({ theme, height }) => ({
  width: '100%',
  height: `${height}px`,
  position: 'relative',
  borderRadius: '2px',
  overflow: 'hidden',
}));

const ProgressBg = styled(Box, {
  shouldForwardProp: (prop) => prop !== 'height',
})<{
  height: number;
}>(({ theme, height }) => ({
  width: '100%',
  height: `${height}px`,
  border: '1px solid #E7E9EC',
  backgroundImage: `repeating-linear-gradient(
    50deg,
    #FFF 0px,
    #FFF 4px,
    #F3F5F6 4px,
    #F3F5F6 7px
  )`,
  backgroundSize: '37px 37px',
  pointerEvents: 'none',
  position: 'absolute',
  left: 0,
  right: 0,
}));

const ProgressBar = styled(Box)<{ percent: number }>(({ percent }) => ({
  width: `${percent}%`,
  height: '100%',
  backgroundImage: `repeating-linear-gradient(
    50deg,
    #257CD3 0px,
    #257CD3 4px,
    #0D6ECE 4px,
    #0D6ECE 7px
  )`,
  backgroundSize: '37px 37px',
  pointerEvents: 'none',
  borderTopLeftRadius: '2px',
  borderBottomLeftRadius: '2px',
  position: 'absolute',
  left: 0,
  right: 0,
}));

const ProgressBar2 = styled(Box)<{ percent: number }>(({ percent }) => ({
  width: `${percent}%`,
  height: '100%',
  backgroundImage: `repeating-linear-gradient(
    50deg,
    #afcfef 0px,
    #afcfef 4px,
    #96bee6 4px,
    #96bee6 7px
  )`,
  backgroundSize: '37px 37px',
  pointerEvents: 'none',
  borderTopLeftRadius: '2px',
  borderBottomLeftRadius: '2px',
  position: 'absolute',
  left: 0,
  right: 0,
}));

const ProgressStripeBar = ({
  percent,
  height = 16,
  ...props
}: {
  percent: number[];
  height?: number;
} & BoxProps) => {
  const p1 = percent[0] > 100 ? 100 : percent[0];
  const p2Sum = percent.length === 2 ? percent[0] + percent[1] : 0;
  const p2 = p2Sum > 100 ? 100 : p2Sum;
  return (
    <ProgressWrapper height={height} {...props}>
      <ProgressBg height={height} />
      {percent.length === 1 && <ProgressBar percent={p1} />}
      {percent.length === 2 && (
        <>
          <ProgressBar2 percent={p2} />
          <ProgressBar percent={p1} />
        </>
      )}
    </ProgressWrapper>
  );
};

export default ProgressStripeBar;
